// Extraction des images d'un presse-papier (collage Ctrl+V d'une capture d'écran).
// Permet de coller un screenshot fait avec l'outil système directement dans le composer.

/**
 * Retourne les fichiers image présents dans un DataTransfer (clipboardData).
 * Filtre sur le type MIME `image/*`. Renvoie un tableau vide si aucune image
 * (collage de texte classique → on laisse le comportement natif suivre son cours).
 */
export function pickImageFiles(data: DataTransfer | null): File[] {
  if (!data || !data.files || data.files.length === 0) return [];
  return Array.from(data.files).filter((f) => f.type.startsWith('image/'));
}
